import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import qs from 'query-string';
import { Dropdown, Input, Button, Grid, Form } from 'semantic-ui-react';
import {
    getSystemAdminUsers
} from '../../actions';
import CommonUtility from "../../utils/CommonUtility";
import { USER_ROLES, USER_TYPE } from "../../constants";

import SysadminUserTable from '../../component/sysadmin/user/user_list_table';

const filterOptions = [
    { key: 'name', text: 'Name', value: 'name' },
    { key: 'nric', text: 'NRIC', value: 'nric' },
    { key: 'studentID', text: 'Student ID', value: 'studentID' },
    { key: 'email', text: 'Email', value: 'email' },
    { key: 'staffId', text: 'Staff ID', value: 'staffId' },
]

const memberOptions = [
    { key: 'a', text: 'All', value: 'all' },
    { key: 'e', text: 'Employee', value: 'e' },
    { key: 'd', text: 'Dependent', value: 'd' },
]

class SysadminUserListPage extends Component {
    state = {
        currentPage: 1,
        perPage: 10,
        totalPage: 1,
        totalData: 1,
        isLoading: false,
        filter: 'name',
        query: '',
        memberType: 'all',
    };

    componentDidMount() {
        if (this.props.user) {
            const { accessToken } = this.props.user;   
            if (accessToken) {
                const query = qs.parse(this.props.location.search)
                let newState = {}
                if (query.page && query.v) {
                    newState = {
                        currentPage: parseInt(query.page),
                        perPage: parseInt(query.v)
                    }
                }
                if (query.filter && query.query) {
                    newState = {
                        ...newState,
                        filter: query.filter,
                        query: query.query
                    }
                }
                if(query.m) {
                    newState = {
                        ...newState,
                        memberType: query.m
                    }
                }
                this.setState({ ...newState }, () => {
                    this.getUsers();
                });
            }
        }
    }

    getUsers = () => {
        const { accessToken } = this.props.user;
        const { clientId } = this.props.match.params;

        let params = {}

        if(clientId){
            params.companyId = clientId;
        }

        if (this.state.query !== '') {
            params[this.state.filter] = this.state.query
        }

        if (this.state.memberType !== 'all') {
            params.withMemberType = this.state.memberType
        }

        params.withUserType = 'client'

        this.setState({ isLoading: true }, () => {
            this.props.getSystemAdminUsers({
                accessToken,
                searchPage: this.state.currentPage,
                searchMax: this.state.perPage,
                params
            }, (result, error) => {
                if(result && result.data && result.data.pagination){
                    this.setState({
                        totalPage: result.data.pagination.totalPage,
                        totalData: result.data.pagination.totalData,
                        isLoading: false,
                    })
                }
            });
        });
    }

    setParams = () => {
        let params = `page=${this.state.currentPage}&v=${this.state.perPage}`
        if (this.state.query !== '') {
            params = params + `&filter=${this.state.filter}&query=${this.state.query}`
        }
        if (this.state.memberType !== 'all') {
            params = params + `&m=${this.state.memberType}`
        }
        this.props.history.push({
            search: params
        })
    }

    goToPreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ currentPage: this.state.currentPage - 1 }, () => {
                this.setParams();
                this.getUsers();
            });
        };
    }

    goToNextPage = () => {
        if (this.props.users.length >= this.state.perPage) {
            this.setState({ currentPage: this.state.currentPage + 1 }, () => {
                this.setParams();
                this.getUsers();
            });
        };
    }

    setPage = (num) => {
        this.setState({ currentPage: num }, () => {
            this.setParams();
            this.getUsers();
        });
    }

    setPerPage = (num) => {
        this.setState({ perPage: num, currentPage: 1 }, () => {
            this.setParams();
            this.getUsers();
        });
    }

    onMemberDropdownChange = (e, { value }) => {
        this.setState({ memberType: value, currentPage: 1 }, () => {
            this.setParams();
            this.getUsers();
        });
    }

    onFilterDropdownChange = (e, { value }) => {
        this.setState({ filter: value });
    }

    submitFilter = () => {
        if (this.state.query !== '') {
            this.setState({...this.state, currentPage: 1}, () => {
                this.setParams();
                this.getUsers();
            });
        }
    }

    clearFilter = () => {
        this.setState({ filter: 'name', query: '', memberType: 'all' }, () => {
            this.props.history.push({
                search: `page=${this.state.currentPage}&v=${this.state.perPage}`
            })
            this.getUsers();
        });
    }

    checkClearFilter = (e) => {
        if(e.target.value == ""){
            this.setState({ filter: 'name', query: '', memberType: 'all' }, () => {
            this.props.history.push({
                search: `page=${this.state.currentPage}&v=${this.state.perPage}`
            })
            this.getUsers();
        });
        }
        this.setState({ query: e.target.value })
    }

    render() {
        const { clientId } = this.props.match.params;
        const isAdminOperation = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.user) && CommonUtility.haveRoles([USER_ROLES.ADMIN_OPERATION], this.props.user);

        return (
            <>  
                <Grid columns="equal">
                    <Grid.Column>
                        { isAdminOperation &&
                            <>
                                <Button as={Link} to={`/systemadmin/user/create`} color="blue" icon="plus" content="Add new user"/>
                                <Button as={Link} to="/systemadmin/user/upload" color="blue" icon="upload" content="Upload user"/> 
                            </>
                        }
                    </Grid.Column>
                    <Grid.Column width={3}>
                        <Dropdown fluid placeholder='Member Type' selection options={memberOptions}
                        value={this.state.memberType} onChange={this.onMemberDropdownChange}/>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Form>
                            <Input fluid type='text' placeholder='Search...' action>
                                <input value={this.state.query} onChange={(e) => this.checkClearFilter(e)} />
                                <Dropdown 
                                    selection 
                                    placeholder='Filter by' 
                                    options={filterOptions}
                                    value={this.state.filter} 
                                    onChange={this.onFilterDropdownChange}/>
                                <Button type="submit" color="green" icon="search" content="Search" onClick={this.submitFilter}/>
                                { this.state.query.length > 0 &&
                                    <Button type="button" color="black" icon="close" content="Clear" onClick={this.clearFilter}/>
                                }
                            </Input>
                        </Form>
                    </Grid.Column>
                </Grid>
                <SysadminUserTable
                    isLoading={this.state.isLoading}
                    users={this.props.users}
                    currentPage={this.state.currentPage}
                    perPage={this.state.perPage}
                    totalPage={this.state.totalPage}
                    totalData={this.state.totalData}
                    setPage={(num) => this.setPage(num)}
                    setPerPage={(num) => this.setPerPage(num)}
                    goToPreviousPage={() => this.goToPreviousPage()}
                    goToNextPage={() => this.goToNextPage()}
                    paginationHandler={this.paginationHandler}
                />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,        
        users: state.systemAdmin.users
    };
}

export default connect(mapStateToProps, {
    getSystemAdminUsers,
})(withRouter(SysadminUserListPage))